var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4167 14.0833L14.0834 23.8333C13.2214 23.8333 12.3948 23.4909 11.7853 22.8814C11.1758 22.2719 10.8334 21.4453 10.8334 20.5833V16.25H4.7017C4.38763 16.2535 4.07655 16.1888 3.79 16.0602C3.50345 15.9316 3.24828 15.7422 3.04219 15.5052C2.83609 15.2682 2.68399 14.9892 2.59641 14.6875C2.50884 14.3859 2.4879 14.0688 2.53503 13.7583L4.03003 4.00832C4.10838 3.49167 4.37081 3.02074 4.76897 2.68231C5.16712 2.34388 5.67418 2.16074 6.1967 2.16665H18.4167M18.4167 14.0833V2.16665M18.4167 14.0833H21.3092C21.9223 14.0942 22.5181 13.8795 22.9834 13.4801C23.4487 13.0807 23.7512 12.5243 23.8334 11.9167V4.33332C23.7512 3.72563 23.4487 3.16928 22.9834 2.76987C22.5181 2.37046 21.9223 2.15581 21.3092 2.16665H18.4167",
    stroke: "currentColor",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/ThumbsDown.6eeaf6f5447e1b0d7f8244a5140f5b81.svg";
export { ForwardRef as ReactComponent };